export const GeocodeStatus = {
  ConfigError: 'CONFIG_ERROR',
  InvalidRequest: 'INVALID_REQUEST',
  SecretError: 'SECRET_ERROR',
  RequestFailed: 'REQUEST_FAILED',
  ZeroResults: 'ZERO_RESULTS',
  Ok: 'OK',
  InternalError: 'INTERNAL_ERROR',
} as const;
